const Theme = {
  body_background_color: 'white',

  header_border_color: '#D8D9DA',

  logo_image_url: 'etchemins.jpg',
  logo_height: 140,

  number_font: `'Oswald', sans-serif`,
  number_weight: 400,

  text_font: `'Source Sans Pro', sans-serif`,
  text_size: 16,

  subtitle_font: `'Oswald', sans-serif`,
  subtitle_weight: 400,
  subtitle_size: 26,
  subtitle_lineheight: 26,

  title_font: `'Lobster', serif`,
  title_size: 34,
  title_weight: 500,
  title_lineheight: 34,

  button_font: `'Source Sans Pro', sans-serif`,
  button_text_weight: 700,
  button_radius: 16,
  button_color: '#34B8A5',

  button_half_text_size: 14,
  button_half_border_color: '#84878B',

  separator_color: '#CDDC28',
  separator_height: 2,

  footer_text_size: 14,
  footer_text_weight: 300,
  footer_border_color: '#D8D9DA',
}

export default Theme
